import React from "react"
import classNames from "classnames"

import { getRoguelikeItem } from "@/utils/assets"

import styles from "./index.module.less"

interface CopperProps {
    id: string
    name?: string
    className?: string
    style?: React.CSSProperties
}

const Copper: React.FC<CopperProps> = (props) => {
    const { id, name, className, style } = props

    return (
        <div className={classNames(styles.copper, className)} style={style}>
            <img src={getRoguelikeItem(id)} loading="lazy" />
            {name ? <div className={styles.name}>{name}</div> : null}
        </div>
    )
}

export default Copper
